import StorageIcon from '@mui/icons-material/Storage';
import SendIcon from '@mui/icons-material/Send';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import PublicIcon from '@mui/icons-material/Public';
import DirectionsBusIcon from '@mui/icons-material/DirectionsBus';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import PinDropIcon from '@mui/icons-material/PinDrop';
import LayersIcon from '@mui/icons-material/Layers';
import WidgetsIcon from '@mui/icons-material/Widgets';
import BuildIcon from '@mui/icons-material/Build';
import MenuIcon from '@mui/icons-material/Menu';
import DesktopWindowsIcon from '@mui/icons-material/DesktopWindows';
import DesktopMacIcon from '@mui/icons-material/DesktopMac';
import LaptopIcon from '@mui/icons-material/Laptop';
import LaptopMacIcon from '@mui/icons-material/LaptopMac';
import LaptopChromebookIcon from '@mui/icons-material/LaptopChromebook';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import DashboardIcon from '@mui/icons-material/Dashboard';
import AssignmentIcon from '@mui/icons-material/Assignment';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import AssignmentLateIcon from '@mui/icons-material/AssignmentLate';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import AssignmentReturnedIcon from '@mui/icons-material/AssignmentReturned';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import LocalAtmIcon from '@mui/icons-material/LocalAtm';
import MoneyOffIcon from '@mui/icons-material/MoneyOff';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import SettingsIcon from '@mui/icons-material/Settings';
import SettingsApplicationsIcon from '@mui/icons-material/SettingsApplications';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import CommentIcon from '@mui/icons-material/Comment';
import ForumIcon from '@mui/icons-material/Forum';
import EmailIcon from '@mui/icons-material/Email';
import MapIcon from '@mui/icons-material/Map';
import ExploreIcon from '@mui/icons-material/Explore';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import LocalTaxiIcon from '@mui/icons-material/LocalTaxi';
import LocalCarWashIcon from '@mui/icons-material/LocalCarWash';
import SecurityIcon from '@mui/icons-material/Security';
import CloudOutlinedIcon from '@mui/icons-material/CloudOutlined';
import HomeIcon from '@mui/icons-material/Home';
import LinkIcon from '@mui/icons-material/Link';
import GridOffIcon from '@mui/icons-material/GridOff';
import BookmarksIcon from '@mui/icons-material/Bookmarks';
import ReceiptIcon from '@mui/icons-material/Receipt';
import DonutLargeIcon from '@mui/icons-material/DonutLarge';
import BarChartIcon from '@mui/icons-material/BarChart';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import DnsIcon from '@mui/icons-material/Dns';
import AssignmentReturnIcon from '@mui/icons-material/AssignmentReturn';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import FolderIcon from '@mui/icons-material/Folder';
import TimerIcon from '@mui/icons-material/Timer';
import TimerOffIcon from '@mui/icons-material/TimerOff';
import StorefrontIcon from '@mui/icons-material/Storefront';
import StoreIcon from '@mui/icons-material/Store';
import AirplayIcon from '@mui/icons-material/Airplay';
import LocalMallIcon from '@mui/icons-material/LocalMall';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import SearchIcon from '@mui/icons-material/Search';
import LabelIcon from '@mui/icons-material/Label';
import CollectionsBookmarkIcon from '@mui/icons-material/CollectionsBookmark';
import ViewCarouselIcon from '@mui/icons-material/ViewCarousel';
import DraftsIcon from '@mui/icons-material/Drafts';
import DeleteIcon from '@mui/icons-material/Delete';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import EventNoteIcon from '@mui/icons-material/EventNote';
import EventIcon from '@mui/icons-material/Event';
import WebIcon from '@mui/icons-material/Web';
import AlarmOnIcon from '@mui/icons-material/AlarmOn';
import LocalGasStationOutlinedIcon from '@mui/icons-material/LocalGasStationOutlined';
import SensorOccupiedOutlinedIcon from '@mui/icons-material/SensorOccupiedOutlined';
import VideocamOutlinedIcon from '@mui/icons-material/VideocamOutlined';
import BuildOutlinedIcon from '@mui/icons-material/BuildOutlined';
import VideocamIcon from '@mui/icons-material/Videocam';
import SummarizeOutlinedIcon from '@mui/icons-material/SummarizeOutlined';
import PolylineOutlinedIcon from '@mui/icons-material/PolylineOutlined';
import PushPinIcon from '@mui/icons-material/PushPin';

// --- TAMBAHAN BARU UNTUK FLEET MANAGEMENT ---
import TwoWheelerIcon from '@mui/icons-material/TwoWheeler';
import ElectricCarIcon from '@mui/icons-material/ElectricCar';
import AirportShuttleIcon from '@mui/icons-material/AirportShuttle';
import CommuteIcon from '@mui/icons-material/Commute';
import DirectionsCarOutlinedIcon from '@mui/icons-material/DirectionsCarOutlined';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import DirectionsBusOutlinedIcon from '@mui/icons-material/DirectionsBusOutlined';
import AgricultureIcon from '@mui/icons-material/Agriculture';
import FireTruckIcon from '@mui/icons-material/FireTruck';
import RvHookupIcon from '@mui/icons-material/RvHookup';
import TireRepairIcon from '@mui/icons-material/TireRepair';
import CarRepairIcon from '@mui/icons-material/CarRepair';
import CarCrashIcon from '@mui/icons-material/CarCrash';
import HandymanIcon from '@mui/icons-material/Handyman';
import EngineeringIcon from '@mui/icons-material/Engineering';
import ConstructionIcon from '@mui/icons-material/Construction';
import LocalGasStationIcon from '@mui/icons-material/LocalGasStation';
import EvStationIcon from '@mui/icons-material/EvStation';
import PropaneIcon from '@mui/icons-material/Propane';
import WaterDropIcon from '@mui/icons-material/WaterDrop';
import BatteryChargingFullIcon from '@mui/icons-material/BatteryChargingFull';
import BatteryFullIcon from '@mui/icons-material/BatteryFull';
import SpeedIcon from '@mui/icons-material/Speed';
import SensorsIcon from '@mui/icons-material/Sensors';
import DeviceThermostatIcon from '@mui/icons-material/DeviceThermostat';
import MemoryIcon from '@mui/icons-material/Memory';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import MyLocationIcon from '@mui/icons-material/MyLocation';
import GpsFixedIcon from '@mui/icons-material/GpsFixed';
import GpsNotFixedIcon from '@mui/icons-material/GpsNotFixed';
import RouteIcon from '@mui/icons-material/Route';
import NavigationIcon from '@mui/icons-material/Navigation';
import AddLocationIcon from '@mui/icons-material/AddLocation';
import MapOutlinedIcon from '@mui/icons-material/MapOutlined';
import BadgeIcon from '@mui/icons-material/Badge';
import PersonIcon from '@mui/icons-material/Person';
import InventoryIcon from '@mui/icons-material/Inventory';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import AssessmentIcon from '@mui/icons-material/Assessment';
import PieChartIcon from '@mui/icons-material/PieChart';
import TimelineIcon from '@mui/icons-material/Timeline';
import TableChartIcon from '@mui/icons-material/TableChart';
import DomainIcon from '@mui/icons-material/Domain';
import BusinessIcon from '@mui/icons-material/Business';
import WarningIcon from '@mui/icons-material/Warning';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import ScheduleIcon from '@mui/icons-material/Schedule';
import UpdateIcon from '@mui/icons-material/Update';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CancelIcon from '@mui/icons-material/Cancel';
import DescriptionIcon from '@mui/icons-material/Description';
import FolderSharedIcon from '@mui/icons-material/FolderShared';

export const zmdiToMuiIconMap = {
  // ==========================================
  // VEHICLE & ARMADA
  // ==========================================
  'zmdi-car': DirectionsCarIcon,
  'zmdi-car-outline': DirectionsCarOutlinedIcon,
  'zmdi-truck': LocalShippingIcon,
  'zmdi-truck-outline': LocalShippingOutlinedIcon,
  'zmdi-bus': DirectionsBusIcon,
  'zmdi-bus-outline': DirectionsBusOutlinedIcon,
  'zmdi-car-taxi': LocalTaxiIcon,
  'zmdi-electric-car': ElectricCarIcon,
  'zmdi-shuttle': AirportShuttleIcon,
  'zmdi-commute': CommuteIcon,
  'zmdi-bike': TwoWheelerIcon,
  'zmdi-agriculture': AgricultureIcon,
  'zmdi-rv': RvHookupIcon,
  'zmdi-fire-truck': FireTruckIcon,

  // ==========================================
  // FUEL, ENERGY & STATION
  // ==========================================
  'zmdi-fuel-station': LocalGasStationOutlinedIcon,
  'zmdi-gas-station': LocalGasStationIcon,
  'zmdi-ev-station': EvStationIcon,
  'zmdi-oil': WaterDropIcon,
  'zmdi-propane': PropaneIcon,
  'zmdi-battery-full': BatteryFullIcon,
  'zmdi-battery-charging': BatteryChargingFullIcon,

  // ==========================================
  // MAINTENANCE & TIRE
  // ==========================================
  'zmdi-wrench': BuildIcon,
  'zmdi-wrench-outlined': BuildOutlinedIcon,
  'zmdi-handyman': HandymanIcon,
  'zmdi-engineering': EngineeringIcon,
  'zmdi-construction': ConstructionIcon,
  'zmdi-tire': TireRepairIcon,
  'zmdi-car-repair': CarRepairIcon,
  'zmdi-car-crash': CarCrashIcon,
  'zmdi-car-wash': LocalCarWashIcon,

  // ==========================================
  // DRIVER & USERS
  // ==========================================
  'zmdi-accounts-alt': PeopleAltIcon,
  'zmdi-accounts-outline': PeopleOutlineIcon,
  'zmdi-person': PersonIcon,
  'zmdi-badge': BadgeIcon,
  'zmdi-assignment-account': AssignmentIndIcon,

  // ==========================================
  // GPS, TRACKING & ROUTE
  // ==========================================
  'zmdi-globe': PublicIcon,
  'zmdi-map': ExploreIcon,
  'zmdi-map-outline': MapOutlinedIcon,
  'zmdi-pin-drop': PinDropIcon,
  'zmdi-pin': PushPinIcon,
  'zmdi-google-maps': MapIcon,
  'zmdi-location': LocationOnIcon,
  'zmdi-my-location': MyLocationIcon,
  'zmdi-gps-fixed': GpsFixedIcon,
  'zmdi-gps-off': GpsNotFixedIcon,
  'zmdi-route': RouteIcon,
  'zmdi-navigation': NavigationIcon,
  'zmdi-add-location': AddLocationIcon,
  'zmdi-polyline': PolylineOutlinedIcon,

  // ==========================================
  // SENSOR, IOT & CAMERA
  // ==========================================
  'zmdi-speed': SpeedIcon,
  'zmdi-sensors': SensorsIcon,
  'zmdi-sensor-occupie-outlined': SensorOccupiedOutlinedIcon,
  'zmdi-thermostat': DeviceThermostatIcon,
  'zmdi-memory': MemoryIcon,
  'zmdi-video-cam': VideocamIcon,
  'zmdi-video-cam-outlined': VideocamOutlinedIcon,
  'zmdi-dns': DnsIcon,

  // ==========================================
  // LOGISTICS, INVENTORY & WAREHOUSE
  // ==========================================
  'zmdi-inventory': InventoryIcon,
  'zmdi-inventory-alt': Inventory2Icon,
  'zmdi-warehouse': WarehouseIcon,
  'zmdi-receipt': ReceiptIcon,
  'zmdi-collection-bookmark': CollectionsBookmarkIcon,

  // ==========================================
  // DASHBOARD, REPORT & ANALYTICS
  // ==========================================
  'zmdi-view-dashboard': DashboardIcon,
  'zmdi-trending-up': TrendingUpIcon,
  'zmdi-chart': BarChartIcon,
  'zmdi-chart-donut': DonutLargeIcon,
  'zmdi-assessment': AssessmentIcon,
  'zmdi-pie-chart': PieChartIcon,
  'zmdi-timeline': TimelineIcon,
  'zmdi-table': TableChartIcon,
  'zmdi-summarize-outlined': SummarizeOutlinedIcon,
  'zmdi-description': DescriptionIcon,

  // ==========================================
  // TIME, SCHEDULE & HISTORY
  // ==========================================
  'zmdi-time-restore': AccessTimeIcon,
  'zmdi-time': AccessTimeIcon,
  'zmdi-timer': TimerIcon,
  'zmdi-timer-off': TimerOffIcon,
  'zmdi-schedule': ScheduleIcon,
  'zmdi-update': UpdateIcon,
  'zmdi-alarm-check': AlarmOnIcon,
  'zmdi-calendar-alt': CalendarTodayIcon,
  'zmdi-calendar-check': EventAvailableIcon,
  'zmdi-calendar-close': EventBusyIcon,
  'zmdi-calendar-note': EventNoteIcon,
  'zmdi-calendar': EventIcon,

  // ==========================================
  // NOTIFICATIONS, SAFETY & ALERTS
  // ==========================================
  'zmdi-notifications-none': NotificationsNoneIcon,
  'zmdi-notifications-active': NotificationsActiveIcon,
  'zmdi-shield-security': SecurityIcon,
  'zmdi-warning': WarningIcon,
  'zmdi-error': ErrorOutlineIcon,

  // ==========================================
  // MAIL, CHAT & COMMUNICATIONS
  // ==========================================
  'zmdi-mail-send': SendIcon,
  'zmdi-email': EmailIcon,
  'zmdi-email-open': DraftsIcon,
  'zmdi-comments': ForumIcon,
  'zmdi-comment-text': CommentIcon,

  // ==========================================
  // COMPANY & ORGANIZATION
  // ==========================================
  'zmdi-domain': DomainIcon,
  'zmdi-business': BusinessIcon,
  'zmdi-store-24': StorefrontIcon,
  'zmdi-store': StoreIcon,

  // ==========================================
  // FINANCE & PAYMENT
  // ==========================================
  'zmdi-balance': AccountBalanceIcon,
  'zmdi-balance-wallet': AccountBalanceWalletIcon,
  'zmdi-money': MonetizationOnIcon,
  'zmdi-money-box': LocalAtmIcon,
  'zmdi-money-off': MoneyOffIcon,

  // ==========================================
  // SYSTEM, SETTINGS & ACTIONS
  // ==========================================
  'zmdi-settings': SettingsIcon,
  'zmdi-settings-square': SettingsApplicationsIcon,
  'zmdi-check-circle': CheckCircleIcon,
  'zmdi-check-outline': CheckCircleOutlineIcon,
  'zmdi-cancel': CancelIcon,
  'zmdi-swap': SwapHorizIcon,
  'zmdi-link': LinkIcon,
  'zmdi-delete': DeleteIcon,
  'zmdi-search': SearchIcon,
  'zmdi-assignment': AssignmentIcon,
  'zmdi-assignment-o': AssignmentOutlinedIcon,
  'zmdi-assignment-check': AssignmentTurnedInIcon,
  'zmdi-assignment-alert': AssignmentLateIcon,
  'zmdi-assignment-return': AssignmentReturnIcon,
  'zmdi-assignment-returned': AssignmentReturnedIcon,
  'zmdi-folder-outline': FolderOpenIcon,
  'zmdi-folder': FolderIcon,
  'zmdi-folder-shared': FolderSharedIcon,
  'zmdi-bookmark': BookmarkIcon,
  'zmdi-label': LabelIcon,

  // ==========================================
  // LAYOUT, DEVICES & MISC
  // ==========================================
  'zmdi-layers': LayersIcon,
  'zmdi-widgets': WidgetsIcon,
  'zmdi-grid-off': GridOffIcon,
  'zmdi-menu': MenuIcon,
  'zmdi-view-carousel': ViewCarouselIcon,
  'zmdi-view-web': WebIcon,
  'zmdi-desktop-windows': DesktopWindowsIcon,
  'zmdi-desktop-mac': DesktopMacIcon,
  'zmdi-laptop': LaptopIcon,
  'zmdi-laptop-mac': LaptopMacIcon,
  'zmdi-laptop-chromebook': LaptopChromebookIcon,
  'zmdi-storage': StorageIcon,
  'zmdi-cloud-outline': CloudOutlinedIcon,
  'zmdi-home': HomeIcon,
  'zmdi-library': BookmarksIcon,
  'zmdi-airplay': AirplayIcon,
  'zmdi-mall': LocalMallIcon,

  default: HelpOutlineIcon
};
